import React from "react";
import { observer } from "mobx-react";
import { FacilityOrderNewFlowClinicalPreviewTemplate } from "themes/application/facility-order-new-flow-clinical/pages";
import { FacilityOrderNewFlowClinicalPreviewViewStore } from "application/facility-order-new-flow-clinical/stores";
import { setCurrentView } from "core/utils";

@setCurrentView(rootStore => new FacilityOrderNewFlowClinicalPreviewViewStore(rootStore), "facilityOrderNewFlowClinicalPreviewViewStore")
@observer
class FacilityOrderNewFlowClinicalPreview extends React.Component {
	render() {
		return <FacilityOrderNewFlowClinicalPreviewTemplate {...this.props} />;
	}
}

export default FacilityOrderNewFlowClinicalPreview;